const FORBIDDEN_KEYS = new Set([
  "roomcode",
  "room_code",
  "matchid",
  "match_id",
  "email",
  "token",
  "password",
  "refcode",
  "viewcode",
  "accesscode",
  "uid",
  "playername",
  "player_name",
  "name",
  "stack",
  "stacktrace",
]);

const EMAIL_RE = /[^\s@]+@[^\s@]+\.[^\s@]+/;

/**
 * Strip sensitive fields and truncate long strings.
 * @param {Record<string, unknown>} raw
 * @returns {Record<string, string | number | boolean>}
 */
export function sanitizeAnalyticsParams(raw) {
  if (!raw || typeof raw !== "object") return {};
  const out = {};
  for (const [key, value] of Object.entries(raw)) {
    const norm = key.toLowerCase().replace(/[^a-z0-9_]/g, "");
    if (FORBIDDEN_KEYS.has(norm)) continue;
    if (value == null) continue;
    if (typeof value === "boolean" || typeof value === "number") {
      out[key] = value;
      continue;
    }
    if (typeof value === "string") {
      if (EMAIL_RE.test(value)) continue;
      const trimmed = value.slice(0, 100);
      if (!trimmed) continue;
      out[key] = trimmed;
    }
  }
  return out;
}
